import { render } from "./OfficeHours-component.vue?vue&type=template&id=124fdfe6&scoped=true"
import script from "./OfficeHours-component.vue?vue&type=script&lang=js"
export * from "./OfficeHours-component.vue?vue&type=script&lang=js"

import "./OfficeHours-component.vue?vue&type=style&index=0&id=124fdfe6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124fdfe6"]])

export default __exports__